
export const StatusObjExternalCourseInit = {
  ALL: true,
  APPROVED: true,
  REJECTED: true,
  PENDING: true,
  CANCELED: true,
};

export const PaginationInit = {
   offset: 0,
    limit: 10,
    totalRecords: 999,
    searchString: "",
    data: [],
    status: StatusObjExternalCourseInit,
};

export const StatusExternalCourse = {
  ALL: "ALL",
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  CANCELED: "CANCELED",
};

export const StatusExternalCourseDescriptions = {
  ALL: "Todos",
  APPROVED: "Validado",
  PENDING: "Em análise",
  REJECTED: "Rejeitado",
  CANCELED: "Cancelado",
};

export const TypeExternalCourseDescriptions = {
  IN_PERSON: "Presencial",
  ONLINE: "Online",
  BLENDED: "Semi-presencial",
};


export const getFileName = (filePath) => {
    // Divide a string pelo caractere "/" e retorna o último elemento
    return filePath.split('/').pop() || '';
};

export const truncateFileName = (name, maxLength = 30) => {
  if (name.length <= maxLength) return name;

  const lastDot = name.lastIndexOf('.');
  if (lastDot === -1) {
    return name.slice(0, maxLength - 3) + '...';
  }

  const ext = name.slice(lastDot); // extensão (.pdf)
  const base = name.slice(0, lastDot);

  const available = maxLength - ext.length - 3; // espaço para o nome
  const start = Math.ceil(available * 0.6);
  const end = available - start;

  return (
    base.slice(0, start) +
    '...' +
    base.slice(base.length - end) +
    ext
  );
}
